import {deleteDocumentById, getDocumentsByPkCode} from "../../../document/api/Document.api";
import {AppId} from "../../../../../common/document/data/AppId";
import {ModuleId} from "../../../../../common/document/data/ModuleId";

export const TYPE_SALARY_CONFIG = {
    import : "import",
    main : "main",
    extra : "extra"
}

export const REF_CODE_BY_CUSTOMER_ID = (customerId) => { // upload mẫu chung cả công ty
    return "bacaf7c8-a694-4682-a928-375d1e45f34d" + "_" + customerId
}

export const REF_CODE_BY_SALARY_CONFIG = (ref) => { // upload mẫu theo file cài đặt
    return ref + "_" + "salary_config"
}

export const CONVERT_REF_CODE_BY_SALARY_CONFIG = (ref) => { // upload mẫu theo file cài đặt
    return ref?.replace("_salary_config","")
}

export const CONCAT_REF_CODE_BY_CUSTOMER_ID = (arr) => {
    return arr
        .filter(item => item !== null && item !== undefined && item !== "")
        .join(":");
}

export function deleteFiles(ref) {
    getDocumentsByPkCode({
        type: 'file',
        pkCode: ref,
        appId: AppId.SALARY.SALARY_TABLE, moduleId: ModuleId.SALARY,
        sort: "modifiedDate:desc"
    }).then(res => {
        res?.items?.forEach(item => {
            deleteDocumentById(item?.id).then(r => {})
        })
    });
}